import { render } from "./MainMenuVisitor.vue?vue&type=template&id=b15fb34a&scoped=true"
import script from "./MainMenuVisitor.vue?vue&type=script&lang=js"
export * from "./MainMenuVisitor.vue?vue&type=script&lang=js"

import "./MainMenuVisitor.vue?vue&type=style&index=0&id=b15fb34a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b15fb34a"]])

export default __exports__